import { INIT_QUIZ, ANSWSER_SUBMIT, SAVE_TESTCASE_RESPONSES_QUIZ, CHANGE_QUIZ_QUESTION, START_QUIZ, GET_RESULT, RESET_QUIZ } from '../Actions/actionTypes';

const INIT_STATE = {
    question: [],
    value: 0
};

const Quiz = (state= INIT_STATE, action) => {
    switch(action.type){
        case START_QUIZ:
            return{
                ...state,
                progressID: action.progressID
            }

        case INIT_QUIZ:
            return{
                ...state,
                question: action.question,
                moduleComplete: action.moduleComplete
            }

        case ANSWSER_SUBMIT:
            let response = { 
                ...state.response, 
                [action.questionID]: { 
                    questionType: action.questionType, 
                    answerSubmitted: action.answerSubmitted, 
                    progressID: action.progressID, 
                    responseID: action.responseID,
                    testCases: action.testCases
                }
            };
            return{
                ...state,
                response
            }

        case SAVE_TESTCASE_RESPONSES_QUIZ:
                let testCases = state.response && state.response[action.questionID] && state.response[action.questionID].testCases ? state.response[action.questionID].testCases : state.question.find(({_id})=>_id === action.questionID).testCases;
                testCases = testCases.map( (testcase) => {
                    if(testcase._id === action.testCaseID){
                        return {
                            ...testcase,
                            status: action.status,
                            programOutput: action.output
                        }
                    }
                    return testcase;
                });
                
                let questionData = (state.response && state.response[action.questionID]) || {};
                response = { ...state.response, [action.questionID]: {...questionData, code: action.code, testCases: testCases}};

                return {
                    ...state,
                    response
                }

        case CHANGE_QUIZ_QUESTION:
            return{
                ...state,
                value: action.value
            }

        case GET_RESULT:
            return{
                ...state,
                result: action.result,
                points: action.points,
                moduleComplete: true
            }

        case RESET_QUIZ:
            return{
                ...state,
                value: 0,
                response: [],
                result: null
            }

        default:
            return state;
    }
}

export default Quiz;